import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../CSS/TeamsPage.css';

const TeamsPage: React.FC = () => {
  const navigate = useNavigate();
  const imagePath = `${process.env.PUBLIC_URL || ''}/assets/Web Version/Team Page/team-page-image.png`;
  
  return (
    <div className="teams-page">
      <div className="teams-hero-banner">
        <div 
          className="teams-hero-background"
          style={{ 
            backgroundImage: `url("${imagePath}")` 
          }}
        ></div>
        <div className="teams-hero-overlay"></div>
        <div className="teams-hero-content">
          <p className="teams-breadcrumb">About Us / <b>Our Team</b></p>
          <h1 className="teams-hero-title">
            "Discover the Dedicated Team Members Who Make Our Vision a Reality Every Day."
          </h1>
        </div>
      </div>
      <div className="our-team">
        <div className="team-grid">
          <div className="team-member">
            <img 
              src={`${process.env.PUBLIC_URL || ''}/assets/Web Version/Team Page/Our Team/manish-mehta-image.png`}
              alt="Manish K Mehta"
              className="team-member-image"
            />
            <Link to="/profile/manish" className="team-member-name">Manish K Mehta</Link>
            <p className="team-member-title">Chairman</p>
          </div>
          <div className="team-member">
            <img 
              src={`${process.env.PUBLIC_URL || ''}/assets/Web Version/Team Page/Our Team/barry-hasenkopf-image.png`}
                alt="J. Barry Hasenkopf"
                className="team-member-image"
              />
            <Link to="/profile/barry-hasenkopf" className="team-member-name">J. Barry Hasenkopf</Link>
            <p className="team-member-title">Chief Executive Officer</p>
          </div>
          <div className="team-member">
            <img 
              src={`${process.env.PUBLIC_URL || ''}/assets/Web Version/Team Page/Our Team/licoln-mehta-image.png`}
              alt="Lincoln Mehta"
              className="team-member-image"
            />
            <Link to="/profile/lincoln-mehta" className="team-member-name">Lincoln Mehta</Link>
            <p className="team-member-title">Chief Financial Officer</p>
          </div>
          <div className="team-member">
            <img 
              src={`${process.env.PUBLIC_URL || ''}/assets/Web Version/Team Page/Our Team/kenny-daugherty-image.png`}
                alt="Kenny Daugherty"
                className="team-member-image"
              />
            <Link to="/profile/kenny-daugherty" className="team-member-name">Kenny Daugherty</Link>
            <p className="team-member-title">President</p>
          </div>
          <div className="team-member">
            <img 
              src={`${process.env.PUBLIC_URL || ''}/assets/Web Version/Team Page/Our Team/jennifer-h-barfield-image.png`}
                alt="Jennifer H. Barfield"
                className="team-member-image"
              />
            <Link to="/profile/jennifer-barfield" className="team-member-name">Jennifer H. Barfield</Link>
            <p className="team-member-title">Executive Vice President and Consultant</p>
          </div>
          <div className="team-member">
            <img 
              src={`${process.env.PUBLIC_URL || ''}/assets/Web Version/Team Page/Our Team/brianna-douglas-image.png`}
                alt="Brianna Douglas"
                className="team-member-image"
              />
            <Link to="/profile/brianna-douglas" className="team-member-name">Brianna Douglas, PhD</Link>
            <p className="team-member-title">Vice President and Consultant</p>
          </div>
          <div className="team-member">
            <img 
              src={`${process.env.PUBLIC_URL || ''}/assets/Web Version/Team Page/Our Team/becky-herman-image.png`}
                alt="Becky Herman"
                className="team-member-image"
              />
            <Link to="/profile/becky-herman" className="team-member-name">Becky Herman</Link>
            <p className="team-member-title">Consultant</p>
          </div>
          <div className="team-member">
            <img 
              src={`${process.env.PUBLIC_URL || ''}/assets/Web Version/Team Page/Our Team/amira-bevill-image.png`}
                alt="Amira Bevill"
                className="team-member-image"
              />
            <Link to="/profile/amira-bevill" className="team-member-name">Amira Bevill</Link>
            <p className="team-member-title">Vice President of Search and Administration</p>
          </div>
          <div className="team-member">
            <img 
              src={`${process.env.PUBLIC_URL || ''}/assets/Web Version/Team Page/Our Team/r-kirby-godsey-image.png`}
                alt="R. Kirby Godsey"
                className="team-member-image"
              />
            <Link to="/profile/kirby-godsey" className="team-member-name">R. Kirby Godsey, PhD</Link>
            <p className="team-member-title">Board Member</p>
          </div>
          <div className="team-member">
            <img 
              src={`${process.env.PUBLIC_URL || ''}/assets/Web Version/Team Page/Our Team/darrel-d-colson-image.png`}
                alt="Darrel D. Colson"
                className="team-member-image"
              />
            <Link to="/profile/darrel-colson" className="team-member-name">Darrel D. Colson, PhD</Link>
            <p className="team-member-title">Senior Consultant</p>
          </div>
          <div className="team-member">
            <img 
              src={`${process.env.PUBLIC_URL || ''}/assets/Web Version/Team Page/Our Team/chris-schuler-image.png`}
                alt="Chris Schuler"
                className="team-member-image"
              />
            <Link to="/profile/chris-schuler" className="team-member-name">Chris Schuler</Link>
            <p className="team-member-title">Consultant</p>
          </div>
          <div className="team-member">
            <img 
              src={`${process.env.PUBLIC_URL || ''}/assets/Web Version/Team Page/Our Team/jessica-thompson-image.png`}
                alt="Jessica Thompson"
                className="team-member-image"
              />
            <Link to="/profile/jessica-thompson" className="team-member-name">Jessica Thompson</Link>
            <p className="team-member-title">Associate Vice President and Executive Search Coordinator</p>
          </div>
          <div className="team-member">
            <img 
              src={`${process.env.PUBLIC_URL || ''}/assets/Web Version/Team Page/Our Team/dina-alkiki.png`}
                alt="Dina Alkiki"
                className="team-member-image"
              />
            <Link to="/profile/dina-alkiki" className="team-member-name">Dina Alkiki</Link>
            <p className="team-member-title">Associate Vice President of Operations and Finance</p>
          </div>
          <div className="team-member">
            <img 
              src={`${process.env.PUBLIC_URL || ''}/assets/Web Version/Team Page/Our Team/jean-callaghan-image.png`}
                alt="Jean Callaghan"
                className="team-member-image"
              />
            <Link to="/profile/jean-callaghan" className="team-member-name">Jean Callaghan</Link>
            <p className="team-member-title">Coordinator of Information Technology</p>
          </div>
        </div>
      </div>
      <div className="our-team-contact">
        <h2 className="team-contact-title">Achieve More Together!</h2>
        <p className="team-contact-subtitle">Connect with the Dedicated Minds Ready to Bring Your Goals to Life.</p>
        <button 
          className="team-contact-button"
          onClick={() => {
            navigate('/contact-us');
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
        >
          Contact Us Today
        </button>
      </div>
    </div>
  );
};

export default TeamsPage;

